import React from 'react';
import { getTime } from '@cian/utils';
import { useDeviceType } from '@cian/ui-kit';

import { formatDate, formatDateToDDMMYYYY } from '../../utils';
import * as s from './DatePublished.css';

interface IDateTimePublished {
  /** Дата строкой вв ISO */
  children: string;
}

/**
 * Дата и время публикации
 */
export const DateTimePublished = ({ children }: IDateTimePublished) => {
  const date = new Date(children);
  const deviceType = useDeviceType();
  const time = getTime(new Date(children));
  const dateTimeFormatted =
    deviceType === 'phone'
      ? `${formatDateToDDMMYYYY(date)}, ${time}`
      : `${formatDate(date, { skipCurrentYear: true })}, ${time}`;

  return (
    <div className={s['wrapper']} title={`${formatDate(date)}, ${time}`}>
      {dateTimeFormatted}
    </div>
  );
};
